import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import Cta from '../Cta';
import PageHeading from '../PageHeading';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import Team from '../Team';
const teamData = [
  {
    memberImage: '/images/team/usama farooq.jpg',
    memberName: 'Usama Farooq',
    memberDesignation: 'Technical Lead (Co-founder)',
    email: 'usamafarooq@dappsterstudio.com',
    memberNumber: '+92 304 4843326',
    memberSocial: {
      linkedin: '/',
      twitter: '/',
      youtube: '/',
      facebook: '/',
    },
  },
  {
    memberImage: '/images/team/shoaib.jpg',
    memberName: 'Shoaib Ali',
    memberDesignation: 'Full Stack Development Lead',
    email: 'shoaibali@dappsterstudio.com',
    memberSocial: {
      linkedin: '/',
      twitter: '/',
      youtube: '/',
      facebook: '/',
    },
  },
  {
    memberImage: '/images/team/ahmed.jpg',
    memberName: 'Ahmad Gujjar',
    memberDesignation: 'Blockchain Development Lead',
    email: 'ahmad@dappsterstudio.com',
    memberSocial: {
      linkedin: '/',
      twitter: '/',
      youtube: '/',
      facebook: '/',
    },
  },
];

export default function TeamPage() {
  pageTitle('Team');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageHeading
        title="Our Team"
        bgSrc="images/team_hero_bg.jpeg"
        pageLinkText="Team"
      />
      <Spacing lg="145" md="80" />
      <Div className="container">
        <SectionHeading
          title="Meet our awesome <br/>team members"
          subtitle="Our Team"
          variant="cs-style1 text-center"
        />
        <Spacing lg="90" md="45" />
        <Div className="row">
          {teamData.map((item, index) => (
            <Div key={index} className="col-lg-4 col-sm-6">
              <Team
                memberImage={item.memberImage}
                memberName={item.memberName}
                memberDesignation={item.memberDesignation}
                memberSocial={item.memberSocial}
                memberEmail={item.email}
                memberNumber={item.memberNumber}
              />
              <Spacing lg="80" md="30" />
            </Div>
          ))}
        </Div>
        <Spacing lg="70" md="50" />
        {/* Start CTA Section */}
        <Div className="container">
          <Cta
            title="Let’s disscuse make <br />something <i>cool</i> together"
            btnText="Book a Call"
            btnLink="https://calendly.com/dappsterstudio/30min"
            btn2Text="Contact Us"
            btn2Link="/contact"
            bgSrc="/images/cta_bg.jpeg"
          />
        </Div>
        {/* End CTA Section */}
      </Div>
    </>
  );
}
